module.exports = __webpack_public_path__ + "static/img/arkusz_materialow.65b8528.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/arkusz_materialow.png
// module id = 8+MQ
// module chunks = 0